import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import { v2Component } from '../../../index';
import { ProductDepreciationConfig } from './product-depreciation-config';
import { TenantContext } from '../../../context/tenant-context';

export function initProductDepreciationConfig(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('product-depreciation-form');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath, productId } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <ProductDepreciationConfig productId={productId} />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
